import React from "react";
import { graphql } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import RobListing from "./RobListing";
import ManagedListing from "./ManagedListing";
import InnsListing from "./InnsListing";
import FeaturedListing from "./FeaturedListing";
import styles from "./styles";

const useStyles = makeStyles((theme) => styles(theme));

export const CgbPubListingBlock = (props) => {
  const classes = useStyles();

  return (
    <div
      className={`pub-listing ${
        props.attributes.className ? props.attributes.className : ""
      } ${classes.pubListing} ${classes.pubListingTheme}`}
    >
      {props.attributes.robinsonsList === true && <RobListing />}
      {props.attributes.managedList === true && <ManagedListing />}
      {props.attributes.innsListing === true && !props.attributes.crm && (
        <InnsListing />
      )}
      {props.attributes.featuredGiftListing === true && <FeaturedListing />}
    </div>
  );
};

export const CgbPubListingBlockFragment = graphql`
  fragment CgbPubListingBlock on WpBlock {
    ... on WpCgbPubListingBlock {
      name
      attributes {
        className
        robinsonsList
        managedList
        innsListing
        featuredGiftListing
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbPubListingBlockPreview = `
    ... on CgbPubListingBlock {
        name
        attributes {
            className
            robinsonsList
            managedList
            innsListing
            featuredGiftListing
        }
    }
`;
